export const searchStringSelector = (state) => state.app.searchString;

export const selectSortingId = (state) => state.app.sortedId;

export const selectCurrentCompany = (state) => state.app.user?.company;
